import React, { useEffect, useState } from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import { REORDER, VIEW_RECEIPT } from '../Constants/PastOrderConstants';
import { isMobileDevice, getDispositionFomatForSelectContent } from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { setAnalyticsData } from 'organisms/ReorderComponent/ReorderUtils/ReorderUtils';
import { getFormatFromUnix } from 'common/utilities/dayJsUtils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';

export const getDate = (dateData, format) => {
  return (
    format &&
    `${getFormatFromUnix(dateData, 'llll').split(' ')[0]} ${getFormatFromUnix(dateData, format.toUpperCase())}`
  );
};

const PastOrderCardComponentIn = props => {
  const { order, tenantReducerData, reorderBtnHandler, viewRecipetHandler } = props;
  const [isMobile, setIsMobile] = useState(isMobileDevice(window.innerWidth));
  const { dateFormat, currencyConversionFactor, currencySymbol, addHope, carryBag } = tenantReducerData;
  const { items = [] } = order;
  const filteredItems = items.filter(foodItem => foodItem?.name !== addHope && foodItem?.name !== carryBag);
  const { ReorderIcon } = IMAGE_PATH;
  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setIsMobile(isMobileView);
  };

  const analyticHandler = (orderInfo, orderedItems) => {
    setAnalyticsData(
      {
        eventType: 'reorder',
        selectedData: orderInfo.name ? orderInfo.name : getDate(orderInfo.orderedOn, dateFormat),
      },
      'orderName',
    );
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
    return () => {
      window.removeEventListener('resize', windowResized);
    };
  }, [isMobile]);

  return (
    <div className='pastorder-card ml-0'>
      <p className='pastorder-card-main-text mt-3 mb-1'>
        {order.name ? order.name : getDate(order.orderedOn, dateFormat)}
      </p>
      <p className='pastorder-card-decomposition-text'>
        {`${filteredItems.length} Items`} • {getDispositionFomatForSelectContent(order.service)} •
        {`${currencySymbol}${(order.total / currencyConversionFactor).toFixed(2)}`}
      </p>
      <div className='pastorder-pastorders-images'>
        {filteredItems.map((item, index) => {
          if (index < 3) {
            return (
              <div className='item-desc' key={index}>
                <span className='item-quantity'>{item?.quantity}</span>
                <span className='item-name'>{item?.name}</span>
              </div>
            );
          } else {
            return null;
          }
        })}
        {filteredItems.length > 3 && <span>{`...`}</span>}
      </div>
      <div className='pastorder-card-button-conatiner'>
        <p className='pastorder-view-details' data-testid={`view-reciept-${order?.id}`} onClick={viewRecipetHandler}>
          {translateWithI18Next(VIEW_RECEIPT)}
        </p>
        <ContainedButton
          data-testid='pastorder-card-button-test'
          className={'pastorder-card-button'}
          variant={ButtonType.primary}
          aria-label={'Reorder button'}
          // onClick={() => {//This analytic is not required so commenting for now
          //   setAnalyticsData(
          //     {
          //       eventType: 'pastorder',
          //       selectedData: order.name ? order.name : getDate(order.orderedOn),
          //     },
          //     'orderName',
          //   );
          // }}
        >
          <img src={ReorderIcon} className='account-icon mr-1' alt='Account Icon' />
          <span
            onClick={() => {
              reorderBtnHandler(order);
              analyticHandler(order, filteredItems);
            }}
            data-testid={`pastorder-btn-test-${order?.id}`}
          >
            {translateWithI18Next(REORDER)}
          </span>
        </ContainedButton>
      </div>
    </div>
  );
};

export default PastOrderCardComponentIn;
